export default __webpack_public_path__ + "custom-theme-0fe59d.gif";